import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import InputField from '../../../../components/form/InputField';
import DateField from '../../../../components/form/DateField';
import FormActionButtons from 'components/Button/FormActionButtons';

const AddKomisi = () => {
  const navigate = useNavigate();
  const [editData, setEditData] = useState(null);

  const [tanggalAwal, setTanggalAwal] = useState('');
  const [tanggalAkhir, setTanggalAkhir] = useState('');
  const [komisiGross, setKomisiGross] = useState('');
  const [maxPremi, setMaxPremi] = useState('');
  const [maxLP, setMaxLP] = useState('');
  const [komisiBersih, setKomisiBersih] = useState('');
  const [document, setDocument] = useState(null);

  useEffect(() => {
  const storedEdit = localStorage.getItem('editKomisi');

  try {
    if (storedEdit) {
      const parsedEdit = JSON.parse(storedEdit);
      if (parsedEdit && typeof parsedEdit === 'object') {
        setEditData(parsedEdit);

        setTanggalAwal(parsedEdit.tanggalAwal || '');
        setTanggalAkhir(parsedEdit.tanggalAkhir || '');
        setKomisiGross(parsedEdit.komisiGross || '');
        setMaxPremi(parsedEdit.maxPremi || '');
        setMaxLP(parsedEdit.maxLP || '');
        setKomisiBersih(parsedEdit.komisiBersih || '');

        if (parsedEdit.document) {
          setDocument({
            url: parsedEdit.document.url,
            name: parsedEdit.document.name,
            type: parsedEdit.document.type,
          });
        }
      }
    }
  } catch (error) {
    console.error('Error parsing editKomisi:', error);
    localStorage.removeItem('editKomisi');
  }
}, []);


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        alert('Ukuran file maksimal 5MB');
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setDocument({ file, url: reader.result, name: file.name, type: file.type });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!tanggalAwal || !tanggalAkhir || !komisiGross || !maxPremi || !maxLP || !komisiBersih) {
      alert('Harap isi semua field wajib');
      return;
    }

    const newKomisi = {
      tanggalAwal,
      tanggalAkhir,
      komisiGross,
      maxPremi,
      maxLP,
      komisiBersih,
      document: document
        ? {
            url: document.url,
            name: document.name,
            type: document.type,
          }
        : null,
    };

    const komisiList = JSON.parse(localStorage.getItem('komisi')) || [];

    if (editData && typeof editData.index === 'number') {
      komisiList[editData.index] = newKomisi;
    } else {
      komisiList.unshift(newKomisi);
    }

    localStorage.setItem('komisi', JSON.stringify(komisiList));
    localStorage.removeItem('editKomisi');
    navigate('/komisi');
  };

  const handleCancel = () => {
    localStorage.removeItem('editKomisi');
    navigate('/komisi');
  };

  return (
    <div className="pl-64 mt-8">
      <form
        onSubmit={handleSubmit}
        className="max-w-3xl p-5 mx-auto bg-white border border-gray-200 shadow-lg rounded-2xl"
      >
        <h2 className="mb-5 text-lg font-semibold text-center text-gray-800 sm:text-xl">
          {editData ? 'Edit Data Komisi' : 'Tambah Data Komisi'}
        </h2>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <DateField
            label="Tanggal Awal"
            value={tanggalAwal}
            onChange={(e) => setTanggalAwal(e.target.value)}
            required
          />
          <DateField
            label="Tanggal Akhir"
            value={tanggalAkhir}
            onChange={(e) => setTanggalAkhir(e.target.value)}
            required
          />
          <InputField
            label="Komisi Gross per Kg (Rp)"
            value={komisiGross}
            onChange={(e) => setKomisiGross(e.target.value)}
            type="number"
            required
          />
          <InputField
            label="Max Premi per Kg (Rp)"
            value={maxPremi}
            onChange={(e) => setMaxPremi(e.target.value)}
            type="number"
            required
          />
          <InputField
            label="Max LP per Kg (Rp)"
            value={maxLP}
            onChange={(e) => setMaxLP(e.target.value)}
            type="number"
            required
          />
          <InputField
            label="Komisi Bersih per Kg (Rp)"
            value={komisiBersih}
            onChange={(e) => setKomisiBersih(e.target.value)}
            type="number"
            required
          />
          <div className="sm:col-span-2">
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Upload Dokumen
            </label>
            <input
              type="file"
              accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
              className="w-full p-2 border rounded-lg"
              onChange={handleFileChange}
            />
            {document && (
              <p className="mt-2 text-sm text-gray-600">
                File:{' '}
                <a href={document.url} target="_blank" rel="noopener noreferrer" className="text-green-700 underline">
                  {document.name}
                </a>{' '}
                ({document.type || 'unknown type'})
              </p>
            )}
          </div>
        </div>

        <FormActionButtons
  onCancel={handleCancel}
  onSubmit={handleSubmit}
  submitLabel={editData ? 'Simpan Perubahan' : 'Simpan'}
  cancelLabel="Batal"
  showCancel={true}
  fullWidth={true}
/>

      </form>
    </div>
  );
};

export default AddKomisi;
